import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["src"]

import { ref } from 'vue'
import axios from "@/api/profile"
import axiosfile from "@/api/files"


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateProfileModal',
  props: {
    profile: {}
  },
  emits: ['close', 'updated'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const form = ref({
  no: props.profile.no,
  title: props.profile.title,
  subContent: props.profile.subContent,
  content: props.profile.content,
  file: null as File | null,       // 선택한 새 이미지 파일
  filePath: props.profile.path, // 기존 이미지 경로 (서버 저장된 파일명 등)
})

const previewUrl = ref<string | null>(props.profile.path)

const onImageChange = (e: Event) => {
  const file = (e.target as HTMLInputElement).files?.[0]
  if (file) {
    console.log(file)
    form.value.file = file
    previewUrl.value = URL.createObjectURL(file)
  }
}

const uploadFile = async (file: File): Promise<string> => {
  const formData = new FormData()
  formData.append('no', props.profile.fileNo)
  formData.append('data', file)
  formData.append('oldFilePath', props.profile.path)
  console.log([...formData.entries()]); 
  const response = await axiosfile.updateFiles( formData)
  console.log(response.data)


  return response.data.filePath
}

const submit = async () => {
  try {
    console.log("나오나요?")
    let newFilePath = form.value.filePath
    if (form.value.file) {
      newFilePath = await uploadFile(form.value.file)
    }

    const res = await axios.UpdateProfile({
      no: form.value.no,
      title: form.value.title,
      subContent: form.value.subContent,
      content: form.value.content,
    })

    console.log(res)
    emit('updated')
    emit('close')
  } catch (err) {
    console.error(err)
  }
}

const close = () => emit('close')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _withModifiers(close, ["self"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, "프로필 수정", -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("label", null, "타이틀", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event))
        }, null, 512), [
          [_vModelText, form.value.title]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("label", null, "서브 타이틀", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.subContent) = $event))
        }, null, 512), [
          [_vModelText, form.value.subContent]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[5] || (_cache[5] = _createElementVNode("label", null, "콘텐츠", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.content) = $event))
        }, null, 512), [
          [_vModelText, form.value.content]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[6] || (_cache[6] = _createElementVNode("label", null, "이미지", -1)),
        _createElementVNode("input", {
          type: "file",
          accept: "image/*",
          onChange: onImageChange
        }, null, 32),
        (previewUrl.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: previewUrl.value,
              class: "preview"
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", { class: "actions" }, [
        _createElementVNode("button", { onClick: submit }, " 저장 "),
        _createElementVNode("button", { onClick: close }, " 닫기 ")
      ])
    ])
  ]))
}
}

})